import { getApplicationResourceManager } from '@neos/app'
import { createEnumType } from '@neos/core'

/**
 * Specifies the CustomViewContentAlign.
 */
export enum CustomViewContentAlign {
  /** Start */
  start = 'Start',
  /** Center */
  center = 'Center',
  /** End */
  end = 'End'
}

export const customViewContentAlignEnumType = createEnumType('CustomViewContentAlign', {
  start: { name: 'Start', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewContentAlign.Start') ?? this.name }, getEnabled() { return true } },
  center: { name: 'Center', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewContentAlign.Center') ?? this.name }, getEnabled() { return true } },
  end: { name: 'End', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewContentAlign.End') ?? this.name }, getEnabled() { return true } },
})
